module.exports = __webpack_public_path__ + "img/coupon_3.8f8a35af.png";